import { createSelector } from 'reselect';
import { RootState } from '../../../types';
import { EntityTypes } from '../../../constants/entities';
import { IEntityReducer } from '../../reducers/entities';
import { ITheme } from 'types/domain/organisation';

const entity = (state: RootState) => state.entity.present;
const id = (state: RootState, id?: number) => id ?? state.state[EntityTypes.THEME];

export const selectTheme = createSelector([entity, id], (entity: IEntityReducer, id: number) => {
  return entity[EntityTypes.THEME][id] as ITheme;
});

export const selectThemes = createSelector([entity], (entity: IEntityReducer) => {
  return Object.values(entity[EntityTypes.THEME]);
});
